import type { NskResponse } from '~/models/Api';
import type { LineUserAccountEdit } from '~/models/LineUserAccount';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';

const paths = {
  create: '/vendors/line_user_accounts',
  update: '/vendors/line_user_accounts/:id',
  destroy: '/vendors/line_user_accounts/:id'
};

export const create = async (
  lineUserAccountEdit: LineUserAccountEdit
): Promise<NskResponse<void>> =>
  postRequest(paths.create, {
    ...lineUserAccountEdit
  });

export const update = async (
  lineUserAccountEdit: LineUserAccountEdit,
  lineUserAccountId: number
): Promise<NskResponse<void>> =>
  putRequest(paths.update.replace(':id', String(lineUserAccountId)), {
    ...lineUserAccountEdit
  });

export const destroy = async (
  lineUserAccountId: number
): Promise<NskResponse<void>> =>
  deleteRequest(paths.destroy.replace(':id', String(lineUserAccountId)));
